import { logout } from "@/store/slices/authSlice";
import {store} from "@store"; // Adjust path to your Redux store
import { toast } from "react-toastify";

const apiClient = async (url, options = {}, navigate = null) => {
  const { token } = store.getState().auth;

  // Only set Content-Type if not FormData
  const isFormData = options.body instanceof FormData;

  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(!isFormData && { "Content-Type": "application/json" }), // <-- only if not FormData
    ...options.headers,
  };

  try {
    const response = await fetch(url, {
      ...options,
      headers,
      credentials: "include",
    });

    // Handle 401 Unauthorized
    if (response.status === 401) {
      if (navigate) {
        navigate("/unauthorized", { replace: true });
      } else {
        window.location.href = "/unauthorized";
      }

      toast.error("Session expired. Please log in again.", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
    }

    if (!response.ok && response.status !== 401) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! Status: ${response.status}`);
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    }

    return {};
  } catch (error) {
    console.error(`API error: ${error.message}`, { url, options });
    throw error;
  }
};


export default apiClient;